import { ReportBlockTypeEnum } from './report-block-type.enum';

export enum ChartTimeIntervalsEnum {
    DYNAMIC = 'DYNAMIC',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    YEAR = 'YEAR'
};

export const defaultChartTypesToTimeIntervalsMap: Map<ReportBlockTypeEnum, ChartTimeIntervalsEnum> = new Map<ReportBlockTypeEnum, ChartTimeIntervalsEnum>([
    [ ReportBlockTypeEnum.COVERAGE_OVER_TIME, ChartTimeIntervalsEnum.DYNAMIC ],
    [ ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, ChartTimeIntervalsEnum.DYNAMIC ],
    [ ReportBlockTypeEnum.COVERAGE_IMPACT_TREND, ChartTimeIntervalsEnum.DYNAMIC ]
]);
